export enum SanityRootProductCategory {
  WALL_ART = 'wallart',
  MENS_CLOTHING = 'mens-clothing',
  WOMENS_CLOTHING = 'womens-clothing',
  KIDS_BABY_CLOTHING = 'kids-baby-clothing',
  TOTE_BAGS = 'tote-bags',
  PHOTO_BOOKS = 'photo-books',
  CARDS = 'cards',
  STATIONERY = 'stationery',
  MUGS = 'mugs',
  PHONE_CASES = 'phone-cases',
  CLEARANCE = 'clearance',
}
